import axios from "axios";
// import { Action_openSideMenu } from "./Action_toggleSideMenu";
const { utils } = require("../../utils")

const
    _API_USER = utils.constants.API.API_USERS,
    _API_OAUTH = utils.constants.API.AUTH;

// const _user = utils.constants.user;


const Action_user_login_passport = () => async (dispatch) => {
console.log('Action_user_login_passport: call from dashboard ')

    try {
        // {
        //     emailID: "yanivsfreelance@gmail.com"
        //     googleID: "105030871163101981765"
        //     name: "oOXx 011o,
        //     id_token: 
        // }

        await dispatch({
            type: utils.constants.USER_LOGIN_REQUEST
        })

        const { data } = await axios.get(_API_OAUTH + '/user', { withCredentials: true })

        dispatch({
            type: utils.constants.USER_LOGIN_SUCCESS,
            payload: { data }
        })


    } catch (error) {

        console.log('error:', error)
        const msg = error.response && error.response.data.msg
            ? error.response.data.msg
            : error.message;

        dispatch({ type: utils.constants.USER_LOGIN_FAIL, payload: msg });
    }

}
const Action_user_logOut_passport = () => async (dispatch) => {

    try {

        await dispatch({
            type: utils.constants.USER_LOGOUT_REQUEST
        })
        // const { data } =
        await axios.get(_API_OAUTH + '/logout', { withCredentials: true })
        // console.log('data:', data)


    } catch (error) {

        console.log('error:', error)
        const msg = error.response && error.response.data.msg
            ? error.response.data.msg
            : error.message;

        dispatch({ type: utils.constants.USER_LOGIN_FAIL, payload: msg });
    }

}
const Action_Admin_user_List = () => async (dispatch) => {

    try {

        await dispatch({
            type: utils.constants.USER_LIST_REQUEST
        })
        const { data } = await axios.get(_API_USER, { withCredentials: true })
        console.log('data:', data)

        dispatch({
            type: utils.constants.USER_LIST_SUCCESS,
            payload: data
        })


    } catch (error) {

        console.log('error:', error)
        const msg = error.response && error.response.data.msg
            ? error.response.data.msg
            : error.message;

        dispatch({ type: utils.constants.USER_LIST_FAIL, payload: msg });
    }

}
const Action_Admin_user_save = (user) => async (dispatch, getState) => {

    try {

        await dispatch({
            type: utils.constants.USER_ADMIN_SAVE_REQUEST
        })
        await axios.post(_API_USER, user, { withCredentials: true })

        let userArr = getState().reducer_user.users.slice();
        const userIndex = Array(userArr).findIndex(i => i._id === user._id)

        userArr.pop(userArr[userIndex])


        dispatch({
            type: utils.constants.USER_ADMIN_SAVE_SUCCESS,
            payload: userArr
        })


    } catch (error) {

        console.log('error:', error)
        const msg = error.response && error.response.data.msg
            ? error.response.data.msg
            : error.message;

        dispatch({ type: utils.constants.USER_ADMIN_SAVE_FAIL, payload: msg });
    }

}



// // user sign or access Token refresh
// const Action_user_login = (userInfo) => async (dispatch, getState) => {

//     try {
//         // {
//         //     emailID: "yanivsfreelance@gmail.com"
//         //     googleID: "105030871163101981765"
//         //     name: "oOXx 011o,
//         //     id_token: 
//         // }

//         //console.log('userInfo.id_token:', userInfo.id_token)
//         if (!userInfo.id_token) {
//             throw new Error('error no: 939jjjs')
//         }

//         await dispatch({
//             type: utils.constants.USER_LOGIN_REQUEST,
//             payload: userInfo.id_token
//         })


//         // console.log('userInfo:', userInfo)

//         const headers_serverValidate_googleToken = utils.get_token_headers(getState)//, userInfo.id_token)
//         // console.log('headers_serverValidate_googleToken:', headers_serverValidate_googleToken)
//         // console.log('headers:', headers)

//         const { data } = await axios.post(_API.API_USERS + _API.USERS.LOGIN, {
//             p_id: userInfo.googleID,
//             email: userInfo.emailID,
//             name: userInfo.name,
//         },
//             headers_serverValidate_googleToken // server validate id_token with email...  
//         )


//         dispatch({
//             type: utils.constants.USER_LOGIN_SUCCESS,
//             payload: {
//                 ...data,
//                 userImg: userInfo?.userImg || '',
//                 googleTokenID: userInfo?.id_token
//             }
//         })

//         localStorage.setItem(utils.constants.user.cookie.COOKIE_USER_INFO, JSON.stringify(data))

//         // dispatch(Action_openSideMenu());

//     } catch (error) {

//         console.log('error:', error)
//         const msg = error.response && error.response.data.msg
//             ? error.response.data.msg
//             : error.message;

//         dispatch({ type: utils.constants.USER_LOGIN_FAIL, payload: msg });
//     }

// }

// const Action_user_logout = () => (dispatch) => {

//     dispatch({
//         type: utils.constants.USER_SET_LOGOUT,
//     })

// }




export {
    //Action_user_login, 
    // Action_user_logout,
    Action_user_login_passport,
    Action_user_logOut_passport,
    Action_Admin_user_List,
    Action_Admin_user_save,
}